<script lang="ts">
	export let checked = false;
</script>

<div class="inline-block">
	<img
		src="/icons/toggles-circle-check.svg"
		alt="circle"
		class="flex-none w-[23px] h-[23px] {checked ? '' : 'hidden'}"
	/>

	<img
		src="/icons/toggles-circle.svg"
		alt="circle"
		class="flex-none w-[23px] h-[23px] {checked ? 'hidden' : ''}"
	/>
</div>
